import ClientDetailTabUser from '@/components/client/DetailTabUser.vue'

const collaboratorRouter = (beforeEnter, name, singleName, basePath, tabs) => {
    return {
        beforeEnter: beforeEnter,
        name: `${singleName}DetalheAbaUsuarios`,
        path: `${basePath}/detalhe/:id/equipe`,
        meta: {
            requiresAuth: true,
            isEmployee: true,
            layout: 'default',
            basePath,
            singleName,
            add: {
                route: `${singleName}DetalheAbaUsuarioCadastrar`,
                label: `Cadastrar usuário`
            },
            editRoute: `${singleName}DetalheAbaUsuarioEditar`,
            tabs
        },
        component: ClientDetailTabUser
    }
}

export default collaboratorRouter
